// API Configuration
const getApiBaseUrl = () => {
  // Production environment
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || 'https://pinyo-api-windows.azurewebsites.net';
  }
  // Development environment
  return process.env.REACT_APP_API_URL || 'http://localhost:5229';
};

export const API_BASE_URL = getApiBaseUrl();

// Event Type Colors - Default palette for calendar events
export const EVENT_TYPE_COLORS: { [key: string]: string } = {
  'training': '#4CAF50',      // Green - Training sessions
  'match': '#F44336',          // Red - Matches
  'tournament': '#FF9800',     // Orange - Tournaments
  'meeting': '#2196F3',        // Blue - Meetings
  'social': '#9C27B0',         // Purple - Social events
  'youth': '#00BCD4',          // Cyan - Youth programs
  'special': '#FFC107',        // Amber - Special events
  'default': '#757575'         // Grey - Default/Unknown
};

// Calendar Configuration
export const CALENDAR_CONFIG = {
  defaultView: 'monthly' as const,
  weekStartsOn: 1, // Monday
  timeSlotDuration: 30, // minutes
  businessHours: {
    start: '06:00',
    end: '22:00'
  }
};

// Date/Time Formats
export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';

// Localization
export const LOCALE = 'hu-HU';

// Feature Flags
export const FEATURES = {
  enableEventCreation: true,
  enableEventEditing: true,
  enableEventDeletion: true,
  enableBulkOperations: false,
  enableRecurringEvents: false,
  enableEventReminders: false,
  enableEventExport: true
};